import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconDragHandle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 6,
	height: 10,
	viewBox: "0 0 6 10",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 1,
			cy: 1,
			r: 1,
			fill: "#C0C0C0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 1,
			r: 1,
			fill: "#C0C0C0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1,
			cy: 5,
			r: 1,
			fill: "#C0C0C0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 1,
			fill: "#C0C0C0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1,
			cy: 9,
			r: 1,
			fill: "#C0C0C0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 9,
			r: 1,
			fill: "#C0C0C0"
		})
	]
});
export default SvgIconDragHandle;
